var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 305,
    viewBox: "0 0 43 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7463 1H11C5.47715 1 1 5.47715 1 11L1 74.9734M1 74.9734L1 190.578V284C1 295.046 9.95431 304 21 304H43M1 74.9734L9.88915 91.9842C13.338 98.5841 20.1681 102.721 27.6149 102.721H42M1 175.613L9.75731 192.371C13.306 199.162 19.9573 203.361 27.1666 203.361H42",
    stroke: "#E0E5EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourGroup);
export default __webpack_public_path__ + "static/media/four-group.e2e5d9f700a19e4b1793ebe375c96b67.svg";
export { ForwardRef as ReactComponent };